<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockReturn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockReturn.pageTitle'),
            href: '/admin/stock-return'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-9">
              <ProductItemDetail
                :validate="errors"
                v-model="model"
                @loading="value => (loading = value)"
              />
            </div>
            <div class="col-md-3">
              <div
                class="ts-bg-gray-200 sm:ts-border-blue-500 ts-rounded-md ts-p-3 ts-space-y-3"
              >
                <div>
                  <label class="required">{{
                    $t('stockReturn.stockReturnDate')
                  }}</label>

                  <a-date-picker
                    v-model="model.return_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                  ></a-date-picker>
                  <div class="validate" v-if="errors.has('return_date')">
                    {{ errors.first('return_date') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockReturn.customer')
                  }}</label>
                  <!-- <a-select
                    v-model="model.customer_id"
                    class="ts-w-full"
                    :options="customers"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  ></a-select> -->
                  <a-select
                    show-search
                    v-model="model.customer_id"
                    style="width: 100%"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    :loading="fetch_customer"
                    @search="handleCustomerSearch"
                  >
                    <a-select-option v-for="c in customers" 
                      :key="c.value"
                      :value="c.value"
                      :opt="c"
                    >
                      {{ c.label }}
                    </a-select-option>
                  </a-select>                  
                  <div class="validate" v-if="errors.has('customer_id')">
                    {{ errors.first('customer_id') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockReturn.returnBy')
                  }}</label>
                  <a-select
                    v-model="model.returned_by"
                    class="ts-w-full"
                    :options="employees"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  ></a-select>
                  <div class="validate" v-if="errors.has('returned_by')">
                    {{ errors.first('returned_by') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockReturn.location')
                  }}</label>
                  <a-select
                    v-model="model.location_id"
                    class="ts-w-full"
                    :options="warehouses"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    disabled
                  ></a-select>
                  <div class="validate" v-if="errors.has('location_id')">
                    {{ errors.first('location_id') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{ $t('stockReturn.reference') }}</label>
                  <input
                    v-model="model.reference_no"
                    type="text"
                    class="form-control"
                  />
                  <div class="validate" v-if="errors.has('reference_no')">
                    {{ errors.first('reference_no') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockReturn.totalAmount')
                  }}</label>
                  <input
                    v-model="model.total_amount"
                    type="number"
                    class="form-control"
                    readonly
                  />
                  <div class="validate" v-if="errors.has('total_amount')">
                    {{ errors.first('total_amount') }}
                  </div>
                </div>
                <div>
                  <label>{{ $t('stockReturn.remark') }}</label>
                  <textarea
                    v-model="model.remarks"
                    rows="3"
                    class="form-control"
                  ></textarea>
                  <div class="validate" v-if="errors.has('total_amount')">
                    {{ errors.first('total_amount') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button
                @click.prevent="$router.push({ name: 'stock-return' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button color="primary" outline @click.prevent="saveAddNew">{{
                $t('save_add_new')
              }}</ts-button>
              <ts-button color="primary" @click.prevent="save">{{
                $t('save')
              }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import ProductItemDetail from './components/product-item-details.vue'
import { Errors } from 'form-backend-validation'
import { sumBy, debounce } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'stockReturnCreate',
  components: {
    ProductItemDetail
  },
  data () {
    return {
      errors: new Errors(),
      loading: false,
      fetch_customer: false,
      customers: [],
      employees: [],
      model: {
        location_id: null,
        returned_by: null,
        reference_no: null,
        remarks: null,
        customer_id: null,
        total_amount: 0,
        product_detail: [],
        return_date: moment().format('DD-MM-YYYY')
      }
    }
  },
  computed: {
    warehouses () {
      return this.$store.state.authUser.user.warehouses.map(el => ({
        value: el.location_id,
        label: el.location_name_en
      }))
    }
  },
  methods: {
    ...mapActions('stock/stockReturn', ['getCustomer', 'getEmployee', 'store']),
    save () {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-return' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveAddNew () {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput () {
      this.model.location_id = null
      this.model.returned_by = null
      this.model.reference_no = null
      this.model.remarks = null
      this.model.customer_id = null
      ;(this.model.total_amount = 0), (this.model.product_detail = [])
      this.model.return_date = moment().format('DD-MM-YYYY')
    },
    calculate () {
      this.model.total_amount = sumBy(this.model.product_detail, o => {
        return o.quantity * o.sale_price
      })
    },
    async fetchResources () {
      this.loading = true
      let responseCustomer = await this.getCustomer()

      this.customers = responseCustomer.data.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))

      let responseEmployee = await this.getEmployee()
      this.employees = responseEmployee.data.map(el => ({
        value: el.user_id,
        label: el.name
      }))

      this.loading = false
    },
    handleCustomerSearch: debounce(async function(value) {
      this.fetch_customer = true
      let responseCustomer = await this.getCustomer({
         search_customer: value
      })
      this.customers = responseCustomer.data.map(el => ({
        value: el.customer_id,
        label: el.customer_name
      }))
      this.fetch_customer = false
    }, 500)
  },
  watch: {
    'model.product_detail': {
      deep: true,
      handler () {
        this.calculate()
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchResources()
    })
  }
}
</script>
